import types from './mutations-types';
import api from './api';

export default {
	async getPlants_({ commit }) {
		let data = await api.getPlants();
		let options = [];
		if (data.body) {
			data.body.map(v => {
				if (v.commCdName !== 'PLANT') {
					options.push({ text: v.commCdName, value: v.commCd });
				}
			});
		}

		commit(types.DEFAULT_ASSIGN, {
			key: 'plants',
			value: options
		});
		commit(types.DEFAULT_ASSIGN, {
			key: 'plantCd',
			value: data.body.length > 0 ? data.body[0].commCd : ''
		});

		return data.header;
	},
	async getScreenUsageHistory_({ commit }, { searchParams, currentPage, pageUnit }) {
		let data = await api.getScreenUsageHistory({ searchParams, currentPage, pageUnit });
		let header = data.header;
		// console.log('~~~~~~~~getScreenUsageHistory', searchParams);
		// if (header.code === 200 || header.code === 404) {
		// 	let body = data.body.resultList;

		// 	body.map((object, index) => {
		// 		object.test = index;
		// 	});
		// 	commit(types.DEFAULT_ASSIGN, {
		// 		key: 'resultList',
		// 		value: body
		// 	});
		// 	commit(types.DEFAULT_ASSIGN, {
		// 		key: 'searchMonth',
		// 		value: searchParams.searchMonth
		// 	});
		// } else {
		// 	console.log('오류 발생');
		// }
		// return data;

		if (data.header.code === 0 /* 오른쪽 조건은 api 응답 수정 후 제거*/ || data.header.code === 200) {
			let body = data.body.resultList;

			body.map((object, index) => {
				object.test = index;
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'resultList',
				value: body
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'groups',
				value: data.body.pagingInfo
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'searchMonth',
				value: searchParams.searchMonth
			});
		} else if (data.header.code === 1) {
		} else if (data.header.code === 2) {
		} else if (data.header.code === 3) {
		} else if (data.header.code === 4) {
		} else if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		} else {
			// somethinig todo
		}

		return data.header;
	}
};
